import { client, extrafeatures, oldLoading } from "../../client";
import { fetchExtensions } from "../../client/fetchLists";

/**
 * Received when the server announces its server info,
 * but we use it as a cue to begin retrieving characters.
 * @param {Array} args packet arguments
 */
export const handleSI = (args: string[]) => {
  client.char_list_length = Number(args[1]);
  client.evidence_list_length = Number(args[2]);
  client.music_list_length = Number(args[3]);

  fetchExtensions();

  // create the charselect grid, to be filled by the character loader
  document.getElementById("client_chartable")!.innerHTML = "";
  const charlist = document.getElementById("client_charlist");
  if (charlist) charlist.innerHTML = "";

  for (let i = 0; i < client.char_list_length; i++) {
    const demothing = document.createElement("img");

    demothing.className = "demothing";
    demothing.loading = "lazy";
    demothing.id = `demo_${i}`;
    const demoonclick = document.createAttribute("onclick");
    demoonclick.value = `pickChar(${i})`;
    demothing.setAttributeNode(demoonclick);

    document.getElementById("client_chartable")!.appendChild(demothing);

    // AO2-style left list entry (small icon + name) mirroring the grid.
    if (charlist) {
      const entry = document.createElement("div");
      entry.className = "charlist-entry";
      entry.id = `charlist_${i}`;
      entry.setAttribute("onclick", `pickChar(${i})`);
      const licon = document.createElement("img");
      licon.className = "charlist-icon";
      licon.loading = "lazy";
      licon.id = `charlist_icon_${i}`;
      const lname = document.createElement("span");
      lname.className = "charlist-name";
      lname.id = `charlist_name_${i}`;
      entry.append(licon, lname);
      charlist.appendChild(entry);
    }
  }

  // this is determined at the top of this file
  if (!oldLoading) {
    client.sender.sendServer("RC#%");
  } else {
    client.sender.sendServer("askchar2#%");
  }
};
